var React = require('react');

function AddedIcon (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","rx":"16","fill":"#45B980","key":0}),React.createElement("path",{"d":"M13.3778 20H19.1318V18.558H15.0158V10.662H13.3778V20Z","fill":"white","key":1})]);
}

AddedIcon.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = AddedIcon;

AddedIcon.default = AddedIcon;
